import { downloadResponseHandler } from 'store/utilities';
import { baseCreateApi } from 'store/apis/baseCreateApi';

export const downloadSlideApi = baseCreateApi.injectEndpoints({
  endpoints: (builder) => ({
    downloadSlideBy: builder.query({
      query: ({ downloadURL }) => ({
        url: downloadURL,
        method: 'GET',
      }),
    }),
    downloadSlideSource: builder.query({
      query: ({ slide }) => ({
        url: slide.download_url,
        method: 'GET',
      }),
      onQueryStarted(_, { queryFulfilled }) {
        downloadResponseHandler(queryFulfilled, 'url');
      },
    }),
    downloadIFSlideSourceQPTiff: builder.query({
      query: ({ IFSlide }) => ({
        url: IFSlide.download_url,
        method: 'GET',
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        downloadResponseHandler(queryFulfilled, 'qptiff_url');
      },
    }),
    downloadIFSlideSourceOMETiff: builder.query({
      query: ({ IFSlide }) => ({
        url: IFSlide.download_url,
        method: 'GET',
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        downloadResponseHandler(queryFulfilled, 'ome_tiff_url');
      },
    }),
  }),
});

export const {
  useDownloadSlideByQuery,
  useLazyDownloadSlideSourceQuery,
  useLazyDownloadIFSlideSourceQPTiffQuery,
  useLazyDownloadIFSlideSourceOMETiffQuery,
} = downloadSlideApi;
